import axios from 'axios'
import checkResponse from "../helpers/responseService";

export default {
    checkResponse (response) {
        if (response) {
            if (!!response.data.deactivated) {
                if (window.location.pathname != '/login') {
                    return window.location.href = '/login'
                }
            } else {
                return response.data
            }
        } else {
            toastr['error']('Ошибка', 'Ошибка')

            return window.location.href = '/login'
        }
    },
    getConversions (params) {
        return axios.get('/conversions/list', {
            params: params
        })
            .then(response => this.checkResponse(response))
    },
    getSourceGroups () {
        return axios.get('/source-groups/get')
            .then(response => this.checkResponse(response))
    },
    deleteConversions (conversionsArray) {
        return axios.post('/conversions/delete', {
            'conversions': conversionsArray
        }).then(response => response)
            .catch(e => e.response)
            .then(response => checkResponse(response))
    },
    uploadConversion(formData) {
        return axios.post('/conversions/upload', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(response => response)
            .catch(e => e.response)
            .then(response => checkResponse(response))
    },
    updateConversion (conversion) {
        return axios.post('/conversions/update/' + conversion.id, conversion)
            .then(response => this.checkResponse(response))
    },
    updateConversions (conversionsData) {
        return axios.post('/conversions/mass-update', conversionsData)
            .then(response => this.checkResponse(response))
    },
    getUsersWithPartnerNetworkId(params) {
        return axios.get('/users/get-network', {
            params: params
        })
            .then(response => {

                return this.checkResponse(response)
            })
    },
}



// WEBPACK FOOTER //
// ./resources/js/services/conversionsDataService.js